import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React, { useContext, useMemo, useState } from 'react';
import { CompanyContext } from '../../../../context/CompanyContext';
import { useMutation } from '@apollo/client';
import { AssetMutations, CreateAssetResponse, CreateAssetVariables } from '../../../../graphql/asset.graphql';
import { Grid } from '@mui/material';
import { CancelButton, CreateButton } from '../../../../VentoryUI/components/common/Button';
import Modal from '../../../../VentoryUI/components/common/Modal';
import { t } from '../../../../types/translation/Translator';
import AssetInfoPane, { AssetInfoType } from './Panes/AssetInfoPane';
import { AssetInput } from '../../../../types/asset/asset.input';
import { AssetTransactionContext } from '../../../../context/AssetTransactionContext';

interface CreateAssetModalInputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pmdId?: string;
}

export default function CreateAssetModal({ open, setOpen, pmdId }: CreateAssetModalInputProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { assetTransactions, setAssetTransactions } = useContext(AssetTransactionContext);

  const [input, setInput] = useState<AssetInput>(
    new AssetInput({
      companyId: currentCompany.id,
      product: { productMasterDataId: pmdId, quantity: 1, unitQuantity: '1' },
    }),
  );
  const [error, setError] = useState<string>('');

  const disabled = useMemo(() => {
    return !input.validate();
  }, [input]);

  const [create, { loading }] = useMutation<CreateAssetResponse, CreateAssetVariables>(AssetMutations.create, {
    onCompleted: res => {
      handleClose();
    },
    onError: res => setError(res.message),
  });

  const handleCreate = async () => {
    try {
      await create({
        variables: {
          assets: [input.forCreate()],
        },
      });
    } catch (e) {
      setError(String(e));
    }
  };

  const handleClose = () => {
    setInput(
      new AssetInput(
        new AssetInput({
          companyId: currentCompany.id,
          product: { productMasterDataId: pmdId, quantity: 1, unitQuantity: '1' },
        }),
      ),
    );
    setOpen(false);
    setError('');
  };

  const footer = () => (
    <Grid container marginTop={'auto'} columnSpacing={1} justifyContent={'flex-end'}>
      <Grid item>
        <CancelButton disabled={loading} onClick={handleClose} />
      </Grid>
      <Grid item>
        <CreateButton loading={loading} disabled={disabled} onClick={handleCreate} />
      </Grid>
    </Grid>
  );

  return (
    <Modal open={open} error={error} onClose={handleClose} title={t(TranslationKey.createNewAsset).singular.label}>
      <AssetInfoPane type={AssetInfoType.create} input={input} setInput={setInput} footer={footer} pmdId={pmdId} />
    </Modal>
  );
}
